import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import {Container, Grid,  Card, Button, Typography, Menu, MenuItem, IconButton , Box} from '@mui/material';
import { fetchClients } from '../../../actions/client';
import {fetchAllProperties} from '../../../actions/property'
import CommonTable from "../../common/table"
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {useSelector, useDispatch} from "react-redux"
import { styled } from '@mui/material/styles';
import SideNav from '../sidenav';
import {CssTextField, clientStyles} from "../../../styles/materialComponent"
import { fetchArbors } from '../../../actions/arboristLogin';
import { validateUserType } from '../../../ValidateUserType';
const property =[
    "Property Name",
    "Client",
    "Address",
    "Actions"
]

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Property = () => {
  const classes = clientStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {clients} = useSelector(({client})=>client)
  const { properties,loader } = useSelector(({property})=>property)
  const {arbors}=useSelector(({arbor})=>arbor)
  const [selectedArbor,setSelectedArbor]=useState(arbors?.length?arbors[0]._id:"")
  const [selectClient,setSelectedClient]=useState(clients?.length?clients[0]._id:"")
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAddClient =()=>{
    setAnchorEl(null);
    navigate("/addClient")
  }

  const handleViewClient =()=>{
    setAnchorEl(null);
    navigate("/clientManager")
  }
  const handleViewProperty =()=>{
    setAnchorEl(null);
    navigate("/properties")
  }

  const handleAddProperties =()=>{
    setAnchorEl(null);
    navigate("/addProperty") 
  }
  useEffect(()=>{
    if(validateUserType()){
      dispatch(fetchArbors())
    }
    else{
      dispatch(fetchAllProperties())
    }
  },[])

  useEffect(()=>{
    setSelectedArbor(arbors?.length?arbors[0]._id:"")
  },[arbors])

  useEffect(()=>{
    setSelectedClient(clients?.length?clients[0]._id:"")
  },[clients])
  
  useEffect(()=>{
    selectedArbor!==""&&dispatch(fetchClients(selectedArbor))
   },[selectedArbor])
   
  useEffect(()=>{
   selectClient!==""&&selectedArbor!==""&&dispatch(fetchAllProperties(selectedArbor,selectClient))
  },[selectedArbor,selectClient])

  return (   
          <Card
          style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", backgroundColor:"#FCFBFD"}}
          className={classes.clientContainer}
          >
            <div style={{padding:15, display: 'flex', justifyContent: 'space-between', padding:20}}>
            <Typography variant="h5">Properties</Typography>
             
             {validateUserType()&&<>
             <CssTextField
          style={{width:"20%",marginLeft:"30%"}}
          InputProps={{ sx: { height: 40 } }}
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Select Arbor"
          name="slectArbor"
          value={selectedArbor}
          onChange={(e)=>{
            setSelectedArbor(e.target.value)
          }}
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          {arbors?.length && arbors.map((op)=>
          <MenuItem value={op?._id}>{op?.firstName}</MenuItem>
          )}
           </CssTextField>

           <CssTextField
          style={{width:"20%"}}
          InputProps={{ sx: { height: 40 } }}
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Select Client"
          name="selectClient"
          value={selectClient}
          onChange={(e)=>setSelectedClient(e.target.value)}
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          {clients.length>0 && clients.map((op)=>
          <MenuItem value={op?._id}>{op?.clientName}</MenuItem>
          )}
           </CssTextField>
             </>}
      
            <Button variant="contained" style={{backgroundColor:"rgb(115 74 153)", textTransform:"none"}} onClick={()=> navigate("/addProperty")}>
              Add Property 
              </Button>
              </div><hr />
              {/* <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
              <MenuItem onClick={handleAddClient}><IconButton><AddCircleOutlineOutlinedIcon /></IconButton>Add Client</MenuItem>
              <MenuItem onClick={handleAddProperties}><IconButton><AddCircleOutlineOutlinedIcon /></IconButton>Add Propery</MenuItem>
              <MenuItem onClick={handleViewClient}><IconButton><VisibilityOutlinedIcon /></IconButton>View Clients</MenuItem>
              <MenuItem onClick={handleViewProperty}><IconButton><VisibilityOutlinedIcon /></IconButton>View Properties</MenuItem>
           </Menu>            */}
            {properties?.length?<CommonTable lable="property" tableCols={property} tableRows={properties}/>:loader?<Box style={{width:"auto",padding:"30px"}}>Processing!</Box>:<Box style={{width:"auto",padding:"30px"}}>No Data Found!</Box>}
       </Card>                        
  )
}

export default Property